// extracted by mini-css-extract-plugin
export default {"form":"AddAnnouncementView_form__1LPD6","error":"AddAnnouncementView_error__yzexL"};